/**
 * AVA-475 — cross-panel channel names.
 *
 * The Context panel (left) owns point selection; the continuous verification
 * wizard lives in the Workspace panel (centre). They are siblings under
 * `views/index.vue`, so selecting or adding a point reaches across through the
 * shared EventBus rather than introducing another guidance surface.
 *
 * DECLARED ONCE, HERE. `MODEL_PICK_EVENTS` is currently declared twice, in
 * `DesignPointModal.vue` and `VerificationViewer.vue`, each with a comment
 * asking the reader to keep the two in step by hand. That is a rename away from
 * a silent breakage — the emit still fires, nothing listens, and the button
 * looks like it works. This channel does not repeat that: both ends import
 * from here. (Consolidating MODEL_PICK_EVENTS onto the same footing is worth
 * doing, but it is not this change.)
 */
export const REPORT_EVENTS = Object.freeze({
  /**
   * "Open the report preview."
   *
   * Same shape and same reason as START_AS_BUILT, mirrored: the Results panel
   * (right) owns the Generate Report button, and the preview is a modal owned by
   * `views/index.vue` — their common parent. The panel says WHAT, not HOW.
   */
  OPEN_PREVIEW: 'verification:open-report-preview',
});

export const CAPTURE_EVENTS = Object.freeze({
  /**
   * Open or refocus the one verification wizard for the active point.
   *
   * Emitted by ContextPanel after Add point or point selection. WorkspacePanel
   * owns the wizard because it also owns model/cloud picking and slice state.
   */
  OPEN_WIZARD: 'verification:open-capture-wizard',

  /**
   * "Begin capturing the as-built point for the active point."
   *
   * WorkspacePanel is the listener. It owns the slice plane, the framing and
   * the pick arming, so the Context panel deliberately says WHAT to do and not
   * HOW — it has no business choosing a slice plane.
   */
  START_AS_BUILT: 'verification:start-as-built-capture',
});

export default CAPTURE_EVENTS;
